var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-history-details-container margin-side" },
    [
      _c("div", { staticClass: "btn-back-wrapper" }, [
        _c("div", {
          staticClass: "btn-back icon-back",
          on: { click: _vm.cancelClick }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-title h2-text" }, [
        _vm._v("Email - Detailed View")
      ]),
      _vm._v(" "),
      _c("div", [_c("EmailHistoryDetails", { attrs: { id: _vm.id } })], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b33a6c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b33a6c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/email/EmailHistoryDetails.vue
// module id = 1841
// module chunks = 1